<template>
	<AppDialog :dialogName="dialogName" :width="900" :max-width="900">
		<div class="subflow-test-dialog">
			<div class="dialog-title">Testing subflow</div>
			<div class="dialog-body pb-4">
				<FlowRun preventDialogs inAppMode :runMetadata="runMetadata" :hashId="subflowHash" @onFlowEnded="onFlowEnded" />
			</div>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from './AppDialog/AppDialog';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import FlowRun from '@/views/FlowRun/FlowRun.vue';

export default {
	name: 'SubflowTestDialog',
	components: {
		AppDialog,
		FlowRun,
	},
	props: {
		dialogName: { type: String },
		currentNodeId: { type: Number },
		subflowHash: { type: String },
		dialogPromiseHandlers: { type: Object },
	},
	data() {
		return { confirmationInput: '', runMetadata: { testMode: true, testModeFromNode: this.currentNodeId /* Yaani Parent */ } };
	},
	methods: {
		onFlowEnded(result) {
			this.dialogPromiseHandlers.resolve(result);
			AppDialogManagerService.closeCurrentDialog(result);
		},
	},
	mounted() {},
};
</script>

<style scoped lang="scss">
.subflow-test-dialog {
	max-height: calc(100vh - 40px);

	::v-deep(.flow-run) {
		.flow-content,
		.widget-form {
			padding: 0 !important;
		}
	}
}
.dialog-body {
	::v-deep(.flow-run) {
		.loader-container {
			height: 100%;
			width: 100%;
		}
		.workflow-status-wrapper {
			margin-bottom: 20px;
		}
	}
}
</style>
